<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-5">
        <current-weather-card :weather="weather" @switch="getWeather" @change-location="launch" v-if="isWeather"></current-weather-card>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-7" v-if="type === 'current'">
        <small-forecast-weather-card :weather="weather" :forecast="forecast" @switch="getWeather" v-if="isWeather&&isForecast"></small-forecast-weather-card>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-7" v-else>
        <forecast-weather-card :forecast="forecast" @switch="getWeather" v-if="isForecast"></forecast-weather-card>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {weather_url, appid, weather_type} from "../../plugins/weatherSettings";
    import CurrentWeatherCard from "../../components/Weather/CurrentWeatherCard";
    import ForecastWeatherCard from "../../components/Weather/ForecastWeatherCard";
    import SmallForecastWeatherCard from "../../components/Weather/SmallForecastWeatherCard";
    import {setCookie, url} from "../../plugins/axios";
    import NotificationTemplate from "../Notifications/NotificationTemplate";

    export default {
      name: "DayPanel",
      components: {SmallForecastWeatherCard, ForecastWeatherCard, CurrentWeatherCard},
      data(){
        return{
          city : 'Salem,oregon',
          coordinates: {
            lat: 44.9429,
            lon: -123.0351,
            accuracy: 4432
          },
          type: 'current',
          isWeather:false,
          isForecast: false,
          weather : {},
          forecast : {},
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        getCurrentPosition() {
          if (navigator.geolocation) {
            return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject))
          }
          else {return new Promise(resolve => resolve({}))}
        },
        async getForecast(url){
          return await axios
            .get(url)
            .then((response) => {
              return response.data;
            });
        },
        async getAddress(){
          return await axios
            .get(url  + 'project-address/myself',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                const res = response.data.result[0].address;
                if (res.split('||').length > 2){
                  let city = res.split('||')[1];
                  city = (city !== '') ? city + ',' : '';
                  if (res.split('||')[2] !== ''){
                    city += res.split('||')[2].split(' ').join(',');
                  }
                  if (city !== ''){
                    this.city = city;
                    return city;
                  }
                  else{
                    return null;
                  }
                }
                else {return null}
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                  this.launch('current')
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        getWeather(type){
          this.type = type;
        },
        launch(type){
          if (type === 'current'){
            this.getCurrentPosition()
              .then((position) => {
                if (position.coords) {
                  this.coordinates.lat = position.coords.latitude;
                  this.coordinates.lon = position.coords.longitude;
                  this.coordinates.accuracy = position.coords.accuracy;
                }
                else {
                  console.log('Geolocation is not supported by this browser.');
                }
              })
              .catch(
                error => {
                  let msg = null;
                  switch(error.code) {
                    case error.PERMISSION_DENIED:
                      msg = "User denied the request for Geolocation.";
                      break;
                    case error.POSITION_UNAVAILABLE:
                      msg = "Location information is unavailable.";
                      break;
                    case error.TIMEOUT:
                      msg = "The request to get user location timed out.";
                      break;
                    case error.UNKNOWN_ERROR:
                      msg = "An unknown error occurred.";
                      break;
                  }
                  console.log(msg);
                })
              .finally(()=>{
                const url = {
                  weather  : weather_url + weather_type.weather  + `?lat=${this.coordinates.lat}&lon=${this.coordinates.lon}&units=imperial&appid=${appid}`,
                  forecast : weather_url + weather_type.forecast + `?lat=${this.coordinates.lat}&lon=${this.coordinates.lon}&units=imperial&appid=${appid}`,
                };
                this.getForecast(url.weather ).then(result => {this.weather  = result; this.isWeather = true;});
                this.getForecast(url.forecast).then(result => {this.forecast = result; this.isForecast = true;});
              })
          }
          else if (type === 'project'){
            this.getAddress()
              .then((city) => {
                if (city === null) {
                  this.notifyVue('warning', "Could not get project's address");
                  return
                }
                const url = {
                  weather  : weather_url + weather_type.weather  + `?q=${city}&units=imperial&appid=${appid}`,
                  forecast : weather_url + weather_type.forecast + `?q=${city}&units=imperial&appid=${appid}`,
                };
                this.getForecast(url.weather ).then(result => {this.weather  = result; this.isWeather  = true;});
                this.getForecast(url.forecast).then(result => {this.forecast = result; this.isForecast = true;});
              })
              .catch(
                error => {
                  return
                })
              .finally(()=>{
              })
          }
        },
      },
      created() {
;       this.launch('current')
      }
    }
</script>

<style scoped>

</style>
